import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'footer'];
var baseStyle = props => {
  var {
    isExpanded,
    heightWhenExpanded,
    heightWhenCollapsed
  } = props;
  return {
    container: {
      borderRadius: 'md',
      border: '1px',
      borderColor: 'grey.300',
      height: isExpanded ? heightWhenExpanded || 'auto' : heightWhenCollapsed || 'auto',
      overflow: isExpanded ? 'auto' : 'hidden'
    },
    footer: {
      px: {
        base: 5,
        md: 10
      },
      pt: {
        base: 10,
        md: 8
      },
      pb: {
        base: 10,
        md: 8
      },
      display: 'flex',
      justifyContent: {
        base: 'center',
        md: 'end',
        mdlg: 'end'
      },
      bg: 'grey.250',
      borderBottomRadius: {
        base: '0',
        md: '0.375rem'
      },
      borderTop: '2px solid',
      borderTopColor: 'grey.400'
    }
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});